import { useEffect, useState } from "react";
import API from "../../Network/API";
import { toast } from "react-hot-toast";

export default function AiProviderSetting() {
    const [providers, setProviders] = useState([
        { id: "deepseek", label: "DeepSeek", model: "deepseek-chat" },
        { id: "openai", label: "ChatGPT", model: "gpt-4o-mini" },
        { id: "anthropic", label: "Claude", model: "claude-3-5-haiku-latest" },
        { id: "ollama", label: "Ollama", model: "llama3.2" },
    ]);
    const [provider, setProvider] = useState("deepseek");
    const [model, setModel] = useState("");
    const [apiKey, setApiKey] = useState("");
    const [ollamaUrl, setOllamaUrl] = useState("");
    const [hasKey, setHasKey] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        API.get("/v1/oauth/agent/settings")
            .then((res) => {
                const data = res.data.data || {};
                if (data.providers?.length) setProviders(data.providers);
                setProvider(data.provider || "deepseek");
                setModel(data.model || "");
                setOllamaUrl(data.ollama_url || "");
                setHasKey(!!data.has_key);
            })
            .catch(() => toast.error("Could not load AI provider settings"));
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        setSaving(true);
        API.post("/v1/oauth/agent/settings", {
            provider,
            model,
            api_key: apiKey,
            ollama_url: ollamaUrl,
        })
            .then((res) => {
                const data = res.data.data || {};
                setHasKey(!!data.has_key);
                setApiKey("");
                toast.success("AI provider saved");
            })
            .catch((err) => toast.error(err.response?.data?.message || "Could not save settings"))
            .finally(() => setSaving(false));
    };

    return (
        <div className="row mt-5 mb-5">
            <div className="col-md-8 offset-md-2">
                <div className="card">
                    <div className="card-header bg-white border-bottom">
                        <h6 className="mb-0">AI Provider</h6>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group row mb-3">
                                <label className="col-md-4 col-form-label text-md-right">AI provider</label>
                                <div className="col-md-6">
                                    <select
                                        className="form-control"
                                        value={provider}
                                        onChange={(e) => {
                                            const next = e.target.value;
                                            setProvider(next);
                                            const found = providers.find((item) => item.id === next);
                                            if (found) setModel(found.model);
                                        }}
                                    >
                                        {providers.map((item) => (
                                            <option key={item.id} value={item.id}>{item.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mb-3">
                                <label className="col-md-4 col-form-label text-md-right">Model</label>
                                <div className="col-md-6">
                                    <input className="form-control" value={model} onChange={(e) => setModel(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row mb-3">
                                <label className="col-md-4 col-form-label text-md-right">API key {hasKey ? "(saved)" : ""}</label>
                                <div className="col-md-6">
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={apiKey}
                                        placeholder="Optional. Server key is used if empty"
                                        onChange={(e) => setApiKey(e.target.value)}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            {provider === "ollama" && (
                                <div className="form-group row mb-3">
                                    <label className="col-md-4 col-form-label text-md-right">Ollama URL</label>
                                    <div className="col-md-6">
                                        <input
                                            className="form-control"
                                            value={ollamaUrl}
                                            placeholder="http://127.0.0.1:11434"
                                            onChange={(e) => setOllamaUrl(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col-md-6 offset-md-4">
                                    <button type="submit" className="btn btn-primary" disabled={saving}>
                                        {saving ? "Saving..." : "Save"}
                                    </button>
                                    <p className="text-muted mt-3 mb-0">Chat and voice use this provider. Calls use ChatGPT.</p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
